export class Franchise {

    contactPerson: string;
    franchiseEntity: string;
    city: string;
    address1: string;
    address2: string;
    zip: string;
    emailId: string;
    state: string;
    county: string;
    phoneNumber: string;
    question1: string;
    question2Comcast: string;
    question2Charter: string;
    question2Att: string;
    question2Other: string;
    question2Comment: string;
    question3: string;
    question4: string;
    question5Dish: string;
    question5Direct: string;
    question5Other: string;
    question5Comment: string;
    question6: string;
    question7: string;
    question7a: number;
    question7b: string;
    question7c: number;
    Question7dRates: string;
    question7dCustomer: string;
    question7dBilling: string;
    question7dService: string;
    question7dOther: string;
    question7dComment: string;
    question8: string;
    question9: string;
    question10: string;
    question10Franchise: string;
    question10Agreement: string;
    question10Peg: string;
    question10Filling: string;
    question10Other: string;
    question10Comment: string;
    question11: string;
    question12Competition: string;
    question12Franchise: string;
    question12Peg: string;
    question12Complaints: string;
    question12Other: string;
    question12Comment: string;
    question13Customer: string;
    question13Peg: string;
    question13Services: string;
    question13ServiceCenter: string;
    question13Other: string;
    question13Comment: string;
    question14: string;
    question15: string;
    question16: string;
    question17: string;
    question18: string;
    customerId: string;



}
